import { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from "@/components/ui/select";

export default function Feedback() {
  const { t, lang } = useLang();
  const [f, setF] = useState({ professional_field: "", country: "", tool_used: "framework",
    usefulness_rating: 4, clarity_rating: 4, would_recommend: true, comments: "" });
  const [done, setDone] = useState(false);
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/feedback", { ...f, language: lang });
      setDone(true); toast.success(t.feedback.success);
    } catch { toast.error("Submission failed"); }
  };

  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-8 py-20" data-testid="feedback-page">
      <h1 className="text-4xl sm:text-5xl font-bold">{t.feedback.title}</h1>
      <p className="mt-4 text-slate-300">{t.feedback.sub}</p>
      {done ? (
        <div className="mt-10 card-mift p-8" data-testid="feedback-success">
          <p className="text-blue-300">{t.feedback.success}</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 card-mift p-6 grid gap-4" data-testid="feedback-form">
          <div><Label className="text-slate-300">{t.forms.professional_field} *</Label>
            <Input data-testid="fb-field" required className="mt-1 bg-[#0A1224] border-slate-700 text-slate-100"
              value={f.professional_field} onChange={(e) => set("professional_field", e.target.value)} /></div>
          <div><Label className="text-slate-300">{t.forms.country} *</Label>
            <Input data-testid="fb-country" required className="mt-1 bg-[#0A1224] border-slate-700 text-slate-100"
              value={f.country} onChange={(e) => set("country", e.target.value)} /></div>
          <div><Label className="text-slate-300">{t.forms.tool_used} *</Label>
            <Select value={f.tool_used} onValueChange={(v) => set("tool_used", v)}>
              <SelectTrigger data-testid="fb-tool" className="mt-1 bg-[#0A1224] border-slate-700"><SelectValue /></SelectTrigger>
              <SelectContent className="bg-[#0A1224] border-slate-700 text-slate-100">
                <SelectItem value="framework">Framework</SelectItem>
                <SelectItem value="cross_border_assessment">Assessment</SelectItem>
                <SelectItem value="mediation_suitability">Mediation Suitability</SelectItem>
                <SelectItem value="toolkit">Toolkit</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {["usefulness_rating", "clarity_rating"].map((k) => (
              <div key={k}><Label className="text-slate-300">{k === "usefulness_rating" ? t.forms.usefulness : t.forms.clarity} *</Label>
                <Input type="number" min={1} max={5} data-testid={`fb-${k}`} className="mt-1 bg-[#0A1224] border-slate-700 text-slate-100"
                  value={f[k]} onChange={(e) => set(k, Number(e.target.value))} /></div>
            ))}
          </div>
          <div><Label className="text-slate-300">{t.forms.would_recommend} *</Label>
            <Select value={String(f.would_recommend)} onValueChange={(v) => set("would_recommend", v === "true")}>
              <SelectTrigger data-testid="fb-rec" className="mt-1 bg-[#0A1224] border-slate-700"><SelectValue /></SelectTrigger>
              <SelectContent className="bg-[#0A1224] border-slate-700 text-slate-100">
                <SelectItem value="true">{t.assessment.opts.yes}</SelectItem>
                <SelectItem value="false">{t.assessment.opts.no}</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div><Label className="text-slate-300">{t.forms.comments}</Label>
            <Textarea data-testid="fb-comments" rows={4} className="mt-1 bg-[#0A1224] border-slate-700 text-slate-100"
              value={f.comments} onChange={(e) => set("comments", e.target.value)} /></div>
          <button className="btn-primary w-max" data-testid="fb-submit">{t.feedback.submit}</button>
        </form>
      )}
    </div>
  );
}
